/** Auth error helpers shared by the login flow. Pure (no Firebase imports) so it
 *  is trivially unit-testable. */

/**
 * True when a sign-in failed only because the account has a second factor and
 * Firebase needs the MFA challenge completed. The login wrapper must surface this
 * (rather than flatten it to a generic error) so the UI can build a
 * MultiFactorResolver — otherwise users with MFA enrolled can never sign in.
 */
export const isMfaChallengeError = (error: any): boolean =>
  !!error && error.code === 'auth/multi-factor-auth-required';
